export default {
  'SLModal.default.okText': 'Hoàn thành',
  'SLModal.default.cacelText': 'Hủy',
  'SLModal.info.okText': 'Đã rõ.'
};